export function tmrOtherView() {
    return Promise.resolve({
        type: 'itemView',
        productid: '',
        pagetype: 'other',
        list: '1'
    });
}